import { isObject, flatMap, snakeCase } from 'lodash';
import { transformKeys } from '@fiverr-private/futile';

/**
 * Extracts all key paths from a source object.
 *
 * For example for the following source:
 *
 * {
 *     a: 1,
 *     b: {
 *         c: 2
 *     }
 * }
 *
 * We will receive: ['a', 'b.c']
 *
 * @param {Object} source
 * @returns {string | string[]}
 */
export const extractKeyPaths = (source, path = '') => {
    if (!source || !isObject(source)) {return path;}

    return flatMap(Object.keys(source), (key) =>
        extractKeyPaths(source[key], path
            ? [path, key].join('.')
            : key
        ));
};

/**
 * Returns a new object or array with all keys as snake case.
 * For example for the following source:
 *
 * {
 *     regular: 'regular',
 *     camelCase: 'camel'
 * }
 *
 * The following output will be provided:
 *
 * {
 *     regular: 'regular',
 *     camel_case: 'camel'
 * }
 *
 * @param {any} source - source object or array to snakeize.
 * @returns {any}
 */
export const snakeize = (source) => transformKeys(source, snakeCase);
